import { t } from "i18next";
import SplitButton from "../../components/button/SplitButton";
import { useUpdateTransferIsInvoicedMutation } from "../../services/bankingService";

import toast from "react-hot-toast";
import { SnackbarSuccess } from "../../components/base/SnackbarAlert/SnackbarSuccess";
import { useToasts } from "../../hooks/useToasts";


export function ChangeTransferIsInvoicedButton(props) {
    const { onFormErrors, onServerError } = useToasts();
    const { mutate: updateTransferIsInvoiced} = useUpdateTransferIsInvoicedMutation({
            onSuccess: () => {
                toast.custom(
                    () => <SnackbarSuccess message={t("successfullyEdited")} />,
                    {
                        position: "bottom-right",
                    },
                );
                props.onSubmit?.()
            },
            onError: (error) => {
                onServerError(error);
            },
        });


  const handleChangeTransferdIsInvoiced = (
    value
  ) => {
    if (props.selectedTransfers?.length === 0) return;

    updateTransferIsInvoiced({transfer_ids: props.selectedTransfers, transfer_is_invoiced: value})
  };

  const massActions = [
    {
      label: t(`true`),
      callback: () => handleChangeTransferdIsInvoiced(true),
    },
    {
      label: t(`false`),
      callback: () =>
        handleChangeTransferdIsInvoiced(false),
    },
  ];

  return (
    <>
      <SplitButton
        label={t("bankings.transferIsInvoicedButton")}
        withChangeSelectedItem={false}
        color={"success"}
        options={massActions}
      />
    </>
  );
}